export function mixin(Hop) {
    Hop.eventEmitter = (target = {}, listeners = {}) => {
        const emitter = Hop.window.BackboneEvents.mixin(target);
        Hop.keys(listeners).forEach((event) => emitter.on(event, listeners[event]));
        return emitter;
    };
}
